import useFetch from '@hooks/useFetch';
import { processClassData } from '@api/hooks/class/utils';
import { emptyObject } from '@constants/empty';
import { HOST_TYPE } from '@utils/api-helper/host';

const classMiddleware = (useSWRNext) => (key, fetcher, config) => {
  const swr = useSWRNext(key, fetcher, config);
  const processedCourseData = swr.data?.processed
    ? swr.data
    : processClassData(swr.data);

  return {
    ...swr,
    data: processedCourseData
  };
};

export const getKey = (classUID) => `v1/uplus/classes/${classUID}/details/`;

const useClassInfo = (
  classUID,
  options = { revalidateOnMount: false, fallbackData: undefined }
) => {
  const key = getKey(classUID);

  const {
    data: classInfo,
    mutate: internalMutate,
    isValidating,
    ...rest
  } = useFetch(
    key,
    {
      hostType: HOST_TYPE.BACKEND_API_HOST
    },
    {
      use: [classMiddleware],
      revalidateOnMount: options.revalidateOnMount,
      fallbackData: options.fallbackData
    }
  );

  const mutate = async () => {
    try {
      const data = await internalMutate();
      return processClassData(data);
    } catch (err) {
      return {
        error: {
          message: 'Unable to fetch course. Please try again!'
        }
      };
    }
  };

  return {
    key,
    classInfo: classInfo || emptyObject,
    mutate,
    isValidating,
    ...rest
  };
};

export default useClassInfo;
